module.exports = __webpack_public_path__ + "components/bike-park-header/static/background--1-18878567b4612b5abe4cddbb76d7399a.jpg";